'use client';

import React, { forwardRef } from 'react';
import { motion, type MotionProps } from 'framer-motion';
import { cn } from '@/lib/utils';
import ResponsiveWrapper, {
  type ResponsiveProperties,
} from './responsive-wrapper.tsx';

export interface ContainerProperties extends MotionProps, ResponsiveProperties {
  id?: string;
  padding?: string;
  margin?: string;
  maxWidth?: string;
  background?: string;
  className?: string;
}

const Container = forwardRef<HTMLDivElement, ContainerProperties>(
  (
    {
      id,
      padding = 'px-4 py-8',
      margin = 'mx-auto',
      maxWidth = 'max-w-lg',
      background = '',
      sm = 'sm:px-4 sm:py-8',
      md = 'md:px-8 md:py-12',
      lg = 'lg:px-12 lg:py-16',
      className = '',
      children,
      ...props
    },
    ref,
  ) => {
    const baseClasses = cn(
      'w-full',
      maxWidth,
      padding,
      margin,
      background,
      className,
    );

    return (
      <ResponsiveWrapper sm={sm} md={md} lg={lg}>
        <motion.div
          ref={ref}
          id={`CONTAINER${id ? `-${id}` : ''}`}
          className={baseClasses}
          {...props}
        >
          {children}
        </motion.div>
      </ResponsiveWrapper>
    );
  },
);

Container.displayName = 'Container';

export default Container;
